import React from 'react';
import './PromoBanner.css';
import { STOCK_BANNER_TITLE, STOCK_COLOUR_NAME, LEAD_STOCK, MADE_TO_ORDER_BANDS } from '../config/leadTimes';

// UX-05: was a perpetually-resetting "ends midnight tonight" countdown.
// The timer rolled over every Melbourne midnight, so any returning
// visitor saw the same "sale ends tonight" message indefinitely. That
// undermines the premium positioning the rest of the site builds.
// Rephrased to a non-time-limited "shop the range" promo with no clock.
// If a real promotion ever runs, wire start/end dates from the DB and
// reintroduce the timer keyed off those.
function PromoBanner({ href = '#range' }) {
  return (
    <section className="asg-promo" aria-label="Shop the range">
      <div className="asg-promo-inner">
        <div className="asg-promo-eyebrow">
          <span className="asg-promo-pct" aria-hidden="true">&#10003;</span>
          <span>In stock now</span>
        </div>
        <h2 className="asg-promo-title">{STOCK_BANNER_TITLE}</h2>
        <p className="asg-promo-sub">{STOCK_COLOUR_NAME} is held in our Hoppers Crossing warehouse and often ships {LEAD_STOCK}. Everything else is made to order: {MADE_TO_ORDER_BANDS}.</p>
        <a className="asg-promo-cta" href={href}>
          Shop the range <span aria-hidden="true">→</span>
        </a>
      </div>
    </section>
  );
}

export default PromoBanner;
